import { displayCategories, DisplayCategory } from '@/api/cms/posts/types';

export const titleBlogData = [
  {
    id: 1,
    value: '',
    title: 'Có gì trên Ahamove',
    desc: 'Nơi cập nhật tất cả tin tức, hoạt động mới nhất từ Ahamove và các đối tác.',
  },
  {
    id: 2,
    value: 'blog',
    title: 'Blog',
    desc: 'Nơi chia sẻ kiến thức, kinh nghiệm từ Ahamove',
  },
  {
    id: displayCategories[DisplayCategory.KHACH_HANG].id,
    value: DisplayCategory.KHACH_HANG,
    title: 'Cổng thông tin khách hàng Ahamove',
    desc: 'Nơi tổng hợp những thông tin dành cho khách hàng Ahamove',
  },
  {
    id: displayCategories[DisplayCategory.TAI_XE].id,
    value: DisplayCategory.TAI_XE,
    title: 'Cổng thông tin tài xế Ahamove',
    desc: 'Nơi tổng hợp những thông tin dành cho tài xế Ahamove',
  },
  {
    id: displayCategories[DisplayCategory.AHAMOVERS].id,
    value: DisplayCategory.AHAMOVERS,
    title: 'Cổng thông tin Ahamovers',
    desc: 'Nơi tổng hợp những thông tin dành cho Ahamovers',
  },
  {
    id: displayCategories[DisplayCategory.DOI_TAC].id,
    value: DisplayCategory.DOI_TAC,
    title: 'Cổng thông tin Đối tác',
    desc: 'Nơi tổng hợp những thông tin dành cho đối tác Ahamove',
  },
  {
    id: displayCategories[DisplayCategory.DONG_HANH_CUNG_THUONG_HIEU].id,
    value: DisplayCategory.DONG_HANH_CUNG_THUONG_HIEU,
    title: displayCategories[DisplayCategory.DONG_HANH_CUNG_THUONG_HIEU].name,
    desc: 'Ahamove muốn trở thành người đồng hành đáng tin cậy của thương hiệu, giúp họ tiếp tục thành công trong kinh doanh. Chúng tôi tin rằng sự hợp tác chặt chẽ với các đối tác sẽ tạo ra sức mạnh, nâng cao nhận diện thương hiệu và tiếp cận đến hàng triệu khách hàng',
  },
];
